import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import { ReactComponent as Background } from 'img/nestleLanding/blue-background.svg';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { PrizeCard } from 'reactApp/sections/Nestle/PrizeCard/PrizeCard';
import { Title } from 'reactApp/sections/Nestle/Title/Title';

import styles from './PrizeBlock.css';

export const PrizeBlock = memo(() => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_mobile]: isMobile,
            })}
        >
            {!isMobile && <Spacing size={50} />}

            <Title
                title="призы для любимых хозяев"
                description="Расскажем про победителей в группе Mail — напомним о дате розыгрыша в письме"
            />
            <Spacing size={isMobile ? 12 : 50} />
            <div className={styles.blocks}>
                <PrizeCard
                    isMobile={isMobile}
                    isBlue
                    title="1 000 ₽"
                    description={<>на подарки для{isMobile ? <br /> : ' '}питомца и себя</>}
                    label="Сертификаты"
                />
                <PrizeCard isMobile={isMobile} title="и приз побольше" label="Сертификаты" />
            </div>
            <Spacing size={isMobile ? 12 : 100} />
            {!isMobile && <Background className={styles.background} />}
        </div>
    );
});

PrizeBlock.displayName = 'PrizeBlock';
